class PaymentMiddlewareUrlService
{
    cardType = 'generating-qr-code';
    paypalType = 'me-qr';

    // PLANS FOR GEN QR CODE
    premiumStarterMonth = 'premium_starter_month';
    premiumStarterYear = 'premium_starter_year';
    premiumProMonth = 'premium_pro_month';
    premiumProYear = 'premium_pro_year';
    premiumBusinessMonth = 'premium_business_month';
    premiumBusinessYear = 'premium_business_year';

    subscriptionTypes = [
        this.premiumStarterMonth,
        this.premiumStarterYear,
        this.premiumProMonth,
        this.premiumProYear,
        this.premiumBusinessMonth,
        this.premiumBusinessYear
    ];

    paymentTypes = {
        card: this.cardType,
        paypal: this.paypalType
    }

    premiumUrl = '/subscription/payment-middleware';

    subscriptionTypeParam = 'type'; // Тип подписки (месячная/годовая)
    currencyParam = 'currency'; // Валюта покупаемой подписки
    couponParam = 'coupon'; // Промокод
    quantityOrderParam = 'quantity_order'; // Количество покупаемых планов
    quantityUnitsParam = 'quantity_units'; // Количество единиц покупаемых mb (для storage подписки)
    trialParam = 'trial'; // Признак покупки триальной подписки
    redirectEntryIdParam = 'redirect_entry_id'; // Id записи, на которую нужно перенаправить после оплаты
    serviceNameParam = "service_name"; // Параметр типа покупки. "me-qr-v2" - покупка картой, "me-qr" - покупка через Paypal

    /**
     * @param subscriptionType {string}
     * @param currency {string|null}
     * @param quantityOrder {number|string|null}
     * @param coupon {string|null}
     * @param trial {boolean}
     * @param redirectEntryId {number|null}
     * @param serviceName {string}
     * @return string
     */
    getPremiumMiddlewareUrl({
        subscriptionType,
        currency= null,
        quantityOrder= null,
        coupon= null,
        trial = false,
        redirectEntryId = null,
        serviceName = this.paymentTypes.card
    }) {
        return this._addQueryParamToUrl({
            url: this.premiumUrl,
            subscriptionType: subscriptionType,
            currency: currency,
            quantityOrder: quantityOrder,
            coupon: coupon,
            trial: trial,
            redirectEntryId: redirectEntryId,
            serviceName
        });
    }

    /**
     * @private
     * @param url {string}
     * @param subscriptionType {string}
     * @param currency {string|null}
     * @param quantityUnits {number|string|null}
     * @param quantityOrder {number|string|null}
     * @param coupon {string|null}
     * @param trial {boolean}
     * @param redirectEntryId {number|null}
     * @param serviceName {string}
     * @return string
     */
    _addQueryParamToUrl({
        url,
        subscriptionType,
        currency= null,
        quantityOrder = null,
        coupon = null,
        quantityUnits = null,
        trial = false,
        redirectEntryId = null,
        serviceName = this.paymentTypes.card
    }) {
        url += `?${this.subscriptionTypeParam}=${subscriptionType}`;

        if (currency) {
            url += `&${this.currencyParam}=${currency}`;
        }
        if (quantityOrder) {
            url += `&${this.quantityOrderParam}=${quantityOrder}`;
        }
        if (coupon) {
            url += `&${this.couponParam}=${coupon}`;
        }
        if (quantityUnits) {
            url += `&${this.quantityUnitsParam}=${quantityUnits}`;
        }
        if (trial) {
            url += `&${this.trialParam}=${trial}`;
        }
        if (redirectEntryId && trial) {
            url += `&${this.redirectEntryIdParam}=${redirectEntryId}`;
        }
        if (serviceName) {
            url += `&${this.serviceNameParam}=${serviceName}`;
        }
        return url;
    }
}

export default (new PaymentMiddlewareUrlService());
